import { JsonObject, JsonProperty } from "ta-json";

import { QueryLoadingResource } from "../../models/query-loading-resource";
import { EntityLoadOption } from "./entity-load-option";

@JsonObject()
export class ScrollRequest extends QueryLoadingResource {
    @JsonProperty("scroll_id")
    scrollId: string;

    @JsonProperty("scroll_time")
    scrollTime: Date; //! TimeSpan

    @JsonProperty("entity_load_options")
    entityLoadOptions: EntityLoadOption;
}
